// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UjdU","left":"styles_left__3uR3M","desktopActions":"styles_desktopActions__1ORG1","title":"styles_title__1uLtb"};